module.exports = __webpack_public_path__ + "static/media/Savannah-Alt-Regular.06f32e9b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Savannah-Alt-Regular.woff2
// module id = 2263
// module chunks = 47